import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateWording } from '../../../store/actions';
import UserAddressMain from '../../../components/User/Address/address.main';

export default function UserAddress() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(updateWording());
    }, [dispatch]);

    return <UserAddressMain />;
}
